const SLA_STYLES = {
  verde: "bg-valoriza-leaf/15 text-valoriza-leaf border-valoriza-leaf/40",
  amarillo: "bg-accent-warning/15 text-accent-warning border-accent-warning/40 tracing-beam",
  rojo: "bg-accent-alert/15 text-accent-alert border-accent-alert/40 tracing-beam-rojo",
};

const SLA_LABELS = { verde: "En plazo", amarillo: "Riesgo SLA", rojo: "SLA vencido" };

export function SlaBadge({ estado }) {
  return (
    <span
      data-testid={`sla-badge-${estado}`}
      className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${SLA_STYLES[estado] || SLA_STYLES.verde}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {SLA_LABELS[estado] || estado}
    </span>
  );
}
